import { useEffect, useState } from 'react';
import Modal from "../../common/ModalPopup";
import { Tab } from 'react-bootstrap';
import { getLeadHistory } from '../../store/slices/insurance';
import dateFormat from "dateformat";

function LeadTimelineModal(props: any) {

    const {viewTimeLine, selectedRemarkLead, handleViewTimeLine,isRemittance} = props;
    const [loading, setLoading] = useState(false);
    const [timelineList, setTimelineList] = useState([]);


    useEffect(()=>{

        if(viewTimeLine){
            setLoading(true);
            const payload = {
                lead_id: selectedRemarkLead,
                ...(isRemittance ? { isRemittance: true } : {})
            }
            getLeadHistory(payload).then((res: any) => {
                setLoading(false);

                if (res.data && res.data.length) {
                    
                    setTimelineList(res.data)
                }
            }).catch(err=> setLoading(false));
        }

    // eslint-disable-next-line
    }, [viewTimeLine])


    return (
        

            <div className="view-timeline-popup image-timeline-popup">
                <Modal show={viewTimeLine} handleClose={() => handleViewTimeLine(false)} >
                    <div className="modal-header">
                        <h2>Collection Timeline</h2>
                    </div>              

                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">

                        <div className="modal-body" >

                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <table>
                                        <tbody>

                                            {
                                                !loading && timelineList.length
                                                    ?
                                                    timelineList.map((timeline: any, idx: number) =>
                                                        <tr key={idx+1}>
                                                            <td>
                                                                <span className="date">{dateFormat(timeline.created_at, 'd mmm, yyyy')}</span>
                                                                <span className="time">{dateFormat(timeline.created_at, 'hh:MM tt')}</span>
                                                            </td>
                                                            <td>
                                                                <span className="heading" dangerouslySetInnerHTML={{ __html: timeline.comment }}></span>
                                                            </td>
                                                            <td>
                                                                {timeline.created_by_name || 'Admin'} <br/>
                                                                {timeline?.role_name &&
                                                                !['payso qr', 'system'].includes(timeline?.created_by_name?.toLowerCase()) && (
                                                                    <span className="badge badge-lead-comming">
                                                                        ({timeline.role_name})
                                                                    </span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                    :
                                                    loading ? <tr><p style={{ textAlign: "center" }}>Loading...</p></tr> : <tr><p style={{ textAlign: "center" }}>No data found</p></tr>

                                            }

                                        </tbody>
                                    </table>

                                </Tab.Pane>

                            </Tab.Content>
                        </div>

                    </Tab.Container>
                </Modal>

            </div>

    )
}

export default LeadTimelineModal;
